import AdvisorEditMap from "../../../components/DataCollection/Advisor/AdvisorEditMap/AdvisorEditMap";

export const AdvisorEditMapScreen = () => {
  return (
    <div>
      <AdvisorEditMap />
    </div>
  );
};
